import { render, staticRenderFns } from "./BestAthletesEventPurchaseDialog.vue?vue&type=template&id=1cfe2026&"
import script from "./BestAthletesEventPurchaseDialog.vue?vue&type=script&lang=ts&"
export * from "./BestAthletesEventPurchaseDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports